/* ***** ----------------------------------------------- ***** **
** ***** Global Scripts JS
** ***** ----------------------------------------------- ***** */

/* global jQuery, Main, TweenMax, Power1, Power2 */
(function($){
	'use strict';

	Main.modules.header = function() {

		var $body = $('body'),
			$content = $('.l-content'),
			$header = $('.c-header'),
			$headerSocialButtons = $('.c-header_social_buttons'),
			$headerPostSlideout = $('.c-header_post_slideout'),
			$headerPostSlideoutItem = $('.c-header_post_slideout-item'),
			$mainNavMenuItem = $('.o-main_nav-menu_item', '.o-main_nav--header'),
			$postHeader = $('.c-post_header'),
			$postHeaderMetadataRow = $('.c-post_header-metadata_row'),
			$socialButtonsToggle = $('.js-social_buttons_toggle'),
			contentWidth = $content.width(),
			documentTop = $(document).scrollTop(),
			hoverDelay = 200,
			transitionDurationSlideout = 0.4,
			transitionDurationSocialButtons = 0.25,
			headerHeight = $header.outerHeight(),
			headerSnapPoint = $('.o-ad_banner--header').outerHeight(),
			utilities = Main.modules.utilities(),
			isMobileWidth = utilities.isMobileWidth(),
			headerPostSlideoutHoverOffTimer,
			headerSocialButtonsHoverOffTimer,
			mainNavMenuItemHoverOffTimer,
			mainNavMenuItemHoverOnTimer,
			socialButtonsHoverOffTimer,
			socialButtonsHoverOnTimer,
			postHeaderHeight,
			postHeaderMetadataRowHeight,
			postHeaderMetadataRowSnapPointMobile,
			postHeaderMetadataRowSnapPointTablet,
			postHeaderTopPosition,

			fixedHeader = function() {

				// When header meets the top of the viewport, snap onto the top
				if (documentTop >= headerSnapPoint) {

					$body.addClass('l-header--fixed');

					if (documentTop >= (headerSnapPoint * 4)) {
						$body.addClass('l-header--small');
					} else {
						$body.removeClass('l-header--small');
					}

				} else {
					$body.removeClass('l-header--fixed');
				}

			},

			fixedMetadataRow = function() {

				postHeaderTopPosition = $postHeader.offset().top;
				postHeaderHeight = $postHeader.outerHeight();
				postHeaderMetadataRowHeight = $postHeaderMetadataRow.height();
				postHeaderMetadataRowSnapPointMobile = headerSnapPoint;
				postHeaderMetadataRowSnapPointTablet = postHeaderTopPosition + postHeaderHeight - headerHeight - postHeaderMetadataRowHeight;

				if (isMobileWidth) {

					// Snap onto the header once the header meets the top of the viewport
					if (documentTop >= postHeaderMetadataRowSnapPointMobile) {
						$body.addClass('l-post_header_metadata_row--fixed');
						$postHeaderMetadataRow.css('width', '');
					} else {
						$body.removeClass('l-post_header_metadata_row--fixed');
					}

				} else {

					// Snap onto the header once the post header metadata row meets the header
					if(documentTop >= postHeaderMetadataRowSnapPointTablet) {
						$body.addClass('l-post_header_metadata_row--fixed');
						$postHeaderMetadataRow.css('width', contentWidth);
					} else {
						$body.removeClass('l-post_header_metadata_row--fixed');
						$postHeaderMetadataRow.css('width', '');
					}

				}

			},

			socialButtonsToggle = function() {

				// When user hovers over a social icon, display social buttons
				$socialButtonsToggle.hover(function() {

					// Clear timer on hover on for hover off actions
					clearTimeout(headerSocialButtonsHoverOffTimer);
					clearTimeout(socialButtonsHoverOffTimer);

					// Set a delay on hover on
					socialButtonsHoverOnTimer = setTimeout(function() {

						var yAmount;

						if ($body.hasClass('l-header--small')) {
							yAmount = 40;
						} else {
							yAmount = 55;
						}
						
						TweenMax.to($headerSocialButtons, transitionDurationSocialButtons, {
							y: yAmount,
							ease: Power1.easeInOut
						});

					}, hoverDelay);

				}, function() {

					// Clear timer on hover off for hover on action
					clearTimeout(socialButtonsHoverOnTimer);

					// Set delay on hover off
					socialButtonsHoverOffTimer = setTimeout(function() {
						// If user does not hover out into the header social buttons section, hide social buttons
						if (!$headerSocialButtons.is(':hover')) {
							socialButtonsClose();
						}
					}, hoverDelay);

				});

				// When user hovers out of the header social buttons section, hide social buttons
				$headerSocialButtons.hover(function() {
					// Do nothing
				}, function() {

					// Set delay on hover off
					headerSocialButtonsHoverOffTimer = setTimeout(function() {
						socialButtonsClose();
					}, hoverDelay);

				});

			},

			socialButtonsClose = function() {

				TweenMax.to($headerSocialButtons, transitionDurationSocialButtons, {
					y: 0,
					ease: Power1.easeInOut
				});

			},

			headerPostSlideoutToggle = function() {

				// When the user hovers over a news nav item with posts, display container with relevant slideout items
				$mainNavMenuItem.hover(function() {

					var $this = $(this),
						$mainNavMenuItemLabel = $this.find('.o-main_nav-menu_item_label').text(),
						$headerPostSlideoutItemLabel = $('.c-header_post_slideout-item[data-main_menu_item="' + $mainNavMenuItemLabel + '"]');

					// Clear timer on hover on for hover off actions
					clearTimeout(mainNavMenuItemHoverOffTimer);
					clearTimeout(headerPostSlideoutHoverOffTimer);

					// Check if news nav item contains posts
					if ($headerPostSlideoutItemLabel.length) {
						$headerPostSlideoutItem.removeClass('c-header_post_slideout-item--is_active');
						$headerPostSlideoutItemLabel.addClass('c-header_post_slideout-item--is_active');

						// Set delay on hover on
						mainNavMenuItemHoverOnTimer = setTimeout(function() {
							TweenMax.to($headerPostSlideout, transitionDurationSlideout, {
								x: 290,
								ease: Power2.easeInOut
							});
						}, hoverDelay);

					} else {
						// Set delay on hover off
						mainNavMenuItemHoverOffTimer = setTimeout(function() {
							headerPostSlideoutClose();
						}, hoverDelay);
					}

				}, function() {

					// Clear timer on hover off for hover on action
					clearTimeout(mainNavMenuItemHoverOnTimer);

					// Set delay on hover off
					mainNavMenuItemHoverOffTimer = setTimeout(function() {
						// If the user does not hover out onto the slideout container, hide slideout
						if (!$headerPostSlideout.is(':hover')) {
							headerPostSlideoutClose();
						}
					}, hoverDelay);

				});

				// When user hovers out of the slideout, hide it
				$headerPostSlideout.hover(function() {
					// Do nothing
				}, function() {

					// Set delay on hover off
					headerPostSlideoutHoverOffTimer = setTimeout(function() {
						headerPostSlideoutClose();
					}, hoverDelay);

				});

			},

			headerPostSlideoutClose = function() {

				TweenMax.to($headerPostSlideout, transitionDurationSlideout, {
					x: 0,
					ease: Power2.easeInOut
				});

			};

		return {
			init: function() {
				fixedHeader();
				socialButtonsToggle();
				headerPostSlideoutToggle();

				if ($body.hasClass('single-post')) {
					fixedMetadataRow();
				}
			},
			fixedHeader: fixedHeader,
			fixedMetadataRow: fixedMetadataRow,
			headerPostSlideoutClose: headerPostSlideoutClose
		}
		
	};

})(jQuery);